/**
 * A calibração que o professor levou ao mapa. Fica no `localStorage`, com a data; o
 * mapa mostra o b calibrado na ficha de cada item, ao lado do b̂ a priori.
 */

import type { ItemCalibrado } from '../engine/calibracao.ts';

const CHAVE = 'itens-iterativos:calibracao';

export function salvarCalibracao(itens: readonly ItemCalibrado[]): void {
  try {
    localStorage.setItem(CHAVE, JSON.stringify({ v: 1, quando: new Date().toISOString(), itens }));
  } catch {
    // sem persistência: a calibração vale só enquanto a página estiver aberta
  }
}

export function carregarCalibracao(): Map<string, ItemCalibrado> {
  try {
    const bruto = localStorage.getItem(CHAVE);
    if (bruto) {
      const o = JSON.parse(bruto) as { v?: unknown; itens?: unknown } | null;
      if (o && o.v === 1 && Array.isArray(o.itens)) {
        return new Map(
          (o.itens as ItemCalibrado[])
            .filter((x) => typeof x?.item === 'string' && typeof x.b === 'number')
            .map((x) => [x.item, x]),
        );
      }
    }
  } catch {
    // armazenamento bloqueado ou corrompido
  }
  return new Map();
}
